import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFindInPage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H15L20 8V19.65L15.45 15C15.6333 14.7167 15.7708 14.4083 15.8625 14.075C15.9542 13.7417 16 13.3833 16 13C16 11.9 15.6083 10.9583 14.825 10.175C14.0417 9.39167 13.1 9 12 9C10.9 9 9.95833 9.39167 9.175 10.175C8.39167 10.9583 8 11.9 8 13C8 14.1 8.39167 15.0417 9.175 15.825C9.95833 16.6083 10.9 17 12 17C12.3833 17 12.7417 16.9542 13.075 16.8625C13.4083 16.7708 13.7167 16.6333 14 16.45L19.2 21.6C18.8167 21.7667 18.4167 21.875 18 21.925C17.5833 21.975 17.1667 22 16.75 22H6ZM12 15C11.45 15 10.9792 14.8042 10.5875 14.4125C10.1958 14.0208 10 13.55 10 13C10 12.45 10.1958 11.9792 10.5875 11.5875C10.9792 11.1958 11.45 11 12 11C12.55 11 13.0208 11.1958 13.4125 11.5875C13.8042 11.9792 14 12.45 14 13C14 13.55 13.8042 14.0208 13.4125 14.4125C13.0208 14.8042 12.55 15 12 15Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFindInPage);
export default ForwardRef;
